/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetContactShareSiteShareFormsResponseData,
  GetContactShareSiteShareFormsResponseDataFromJSON,
  GetContactShareSiteShareFormsResponseDataFromJSONTyped,
  GetContactShareSiteShareFormsResponseDataToJSON
} from './GetContactShareSiteShareFormsResponseData'

/**
 *
 * @export
 * @interface GetContactShareSiteUnifiedShareFormsResponse
 */
export interface GetContactShareSiteUnifiedShareFormsResponse {
  /**
   *
   * @type {number}
   * @memberof GetContactShareSiteUnifiedShareFormsResponse
   */
  status?: number
  /**
   *
   * @type {GetContactShareSiteShareFormsResponseData}
   * @memberof GetContactShareSiteUnifiedShareFormsResponse
   */
  data?: GetContactShareSiteShareFormsResponseData
}

export function GetContactShareSiteUnifiedShareFormsResponseFromJSON(
  json: any
): GetContactShareSiteUnifiedShareFormsResponse {
  return GetContactShareSiteUnifiedShareFormsResponseFromJSONTyped(json, false)
}

export function GetContactShareSiteUnifiedShareFormsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetContactShareSiteUnifiedShareFormsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetContactShareSiteShareFormsResponseDataFromJSON(json['data'])
  }
}

export function GetContactShareSiteUnifiedShareFormsResponseToJSON(
  value?: GetContactShareSiteUnifiedShareFormsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetContactShareSiteShareFormsResponseDataToJSON(value.data)
  }
}
